import { SalesDespatchItemInvoiceReport } from './sales-despatch-item-invoice-report';
import { SalesDespatchProductReportInvoice } from './sales-despatch-product-report-invoice';
import { SalesInvoiceDeliveryReport } from './sales-invoice-delivery-report';
import { SalesInvoiceExtraReport } from './sales-invoice-extra-report';
import { SalesInvoicePackSummaryReport } from './sales-invoice-pack-summary-report';
import { SalesInvoiceQualitySummaryReport } from './sales-invoice-quality-summary-report';
import { SalesInvoiceItems } from '../sales-invoice-items';
import { SellingCompanyReport } from '../../../../tms-shared';
import { SalesInvoiceProductSummaryReport } from './sales-invoice-product-summary-report';
import { SalesInvoiceCustomsSummaryReport } from './sales-invoice-customs-summary-report';
import { SalesInvoiceOrderReport } from './sales-invoice-order-report';

export interface SalesInvoiceReport {
  id: string;
  invoiceNo: number;
  dateInvoiced: Date;
  despatchNoteNo: number;
  despatchDate: Date;
  customerKey: string;
  customerName: string;
  customerInvoiceRef: string;
  customerInvoiceEmail: string;
  customerAddressMultiLine: string;
  deliveryAddressMultiLine: string;
  invoiceAddressee: string;
  invoiceAddressMultiLine: string;
  shipperSupplier: string;
  paymentTerms: string;
  paymentDueDate: Date;
  deliveryTerm: string;
  deliveryTermNotes: string;
  modeOfTransport: string;
  currencyCode: string;
  currencySymbol: string;
  documentNotes: string;
  notes: string;
  proforma: boolean;
  taxCode: string;
  taxRate: number;
  grossQuantity: number;
  nettQuantity: number;
  noOfItems: number;
  goodsValue: number;
  processValue: number;
  totalDeliveryValue: number;
  totalExtraValue: number;
  depositPaid: number;
  discountValue: number;
  nettValue: number;
  taxValue: number;
  overallValue: number;
  overallLessDepositTotal: number;
  bankAccountName: string;
  bankName: string;
  bankIBAN: string;
  bankSwift: string;
  bankAccount: string;
  bankSortCode: string;
  bankBIC: string;
  bankAddress: string;
  bankReference: string;
  bankNarrative: string;
  bankPayable: string;
  paymentTermsMessage: string;
  orderPlacedBy: string;
  orderNumber: string;
  customerOrderNumber: string;
  customerOrderRef: string;
  documentMessage: string;
  countryDeclaration: string;
  deliveryAddressee: string;
  printDeliveryAddress: boolean;
  trackingNo: string;
  decimalPlaces: number;
  showStockItems: string;

  sellingCompany: SellingCompanyReport;
  salesDespatchItems: SalesDespatchItemInvoiceReport[];
  salesInvoiceOrders: SalesInvoiceOrderReport[];
  salesDespatchProducts: SalesDespatchProductReportInvoice[];
  salesInvoiceDeliveryItems: SalesInvoiceDeliveryReport[];
  salesInvoiceExtraItems: SalesInvoiceExtraReport[];
  salesPackSummary: SalesInvoicePackSummaryReport[];
  salesInvoiceItems: SalesInvoiceItems[];
  salesInvoiceQualitySummary: SalesInvoiceQualitySummaryReport[];
  salesInvoiceProductSummaryReport: SalesInvoiceProductSummaryReport[];
  salesInvoiceCustomsSummaryReport: SalesInvoiceCustomsSummaryReport[];
}
